import { createStore, combineReducers, applyMiddleware } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
import authReducer from "./app/reducers/authReducer";
import partidasReducer from "./app/reducers/partidasReducer";

export default createStore(
  combineReducers({
    partidasReducer,
    authReducer
  }),
  {},
  applyMiddleware(logger, thunk, promise())
);
